import React from "react";
import RecentCommentsPanel from "./RecentCommentsPanel";
import RecentCommentsStrip from "./RecentCommentsStrip";
import RecentDownloadsPanel from "./RecentDownloadsPanel";

const CommunityHub: React.FC = () => {
    return (
        <div className="w-full bg-black">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-0 min-h-[240px]">
                {/* Left Section - Kommentek */}
                <div className="bg-gray-900 md:border-r border-b md:border-b-0 border-gray-800 flex flex-col">
                    <h3 className="text-2xl font-bold text-primary mb-4 px-6 pt-6">Kommentek</h3>
                    <div className="flex-1 px-6 pb-6">
                        <RecentCommentsPanel maxItemsPerView={1} />
                    </div>
                </div>

                {/* Middle Section - Utolsó 10 letöltés */}
                <div className="bg-gray-900 md:border-r border-b md:border-b-0 border-gray-800 flex flex-col">
                    <h3 className="text-2xl font-bold text-primary mb-4 px-6 pt-6">Utolsó 10 letöltés</h3>
                    <div className="flex-1 px-6 pb-6 overflow-hidden flex flex-col">
                        <RecentDownloadsPanel />
                    </div>
                </div>

                {/* Right Section - Fórum hozzászólások */}
                <div className="bg-gray-900 flex flex-col">
                    <h3 className="text-2xl font-bold text-primary mb-4 px-6 pt-6">Fórum hozzászólások</h3>
                    <div className="flex-1 px-6 pb-6">
                        <RecentCommentsStrip />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommunityHub;
